module.exports = __webpack_public_path__ + "img/loading_latino.47833cea.gif";